<template>
	<div class="content">
		<h3>{{dialogtype === 1 ? '用户编辑' : '用户设置'}}</h3>
		<div class="item">
			<el-form ref="form" style="width:auto" :model="form" :rules="rules" label-width="150px">				
				<el-form-item label="用户名" prop="username">
					<el-input :disabled="dialogtype==1" v-model="form.username"></el-input>
				</el-form-item>
				<el-form-item label="密码" prop="password">
					<el-input :disabled="dialogtype==1" show-password  v-model="form.password"></el-input>
				</el-form-item>
				<el-form-item label="确认密码" prop="confirm">
					<el-input :disabled="dialogtype==1" show-password v-model="form.confirm" ></el-input>
				</el-form-item>
				<el-form-item label="真实姓名" prop="name">
					<el-input v-model="form.name"></el-input>
				</el-form-item>
				<el-form-item label="性别" prop="sex" style="text-align: center;">
					<el-radio v-model="form.sex" :label='true'>男</el-radio>
  					<el-radio v-model="form.sex" :label='false'>女</el-radio>
				</el-form-item>
				<el-form-item label="联系电话" prop="tel">
					<el-input v-model="form.tel"></el-input>
				</el-form-item>
				<el-form-item label="状态" prop="state" style="text-align: center;">
					<el-radio v-model="form.state" :label='1'>启用</el-radio>
  					<el-radio v-model="form.state" :label='0'>禁用</el-radio>
				</el-form-item>
				<el-form-item label="是否为经销商" prop="isAgcy" style="text-align: center;">
					<el-radio v-model="form.isAgcy" :label='1'>是</el-radio>
  					<el-radio v-model="form.isAgcy" :label='0'>否</el-radio>
				</el-form-item>
				<el-form-item v-if="form.isAgcy" label="经销商" prop="Agcyname">
					<el-input v-model="form.Agcyname"></el-input>
				</el-form-item>
			</el-form>
			<div class="btn">
				<el-button v-if="dialogtype==0" @click="restForm" type="warning">重 置</el-button>
				<el-button v-if="dialogtype==1" @click="exitUpdata" type="danger">取 消</el-button>
				<el-button type="primary" @click="AddUserInfo('form')">保 存</el-button>
			</div>
		</div>
		<div class="item" >
			<el-table :data="tableData" border >
				<el-table-column prop="UserName" align="center" label="用户名"></el-table-column>
				<el-table-column prop="DisplayName" align="center" label="真实姓名"></el-table-column>
				<el-table-column align="center" label="性别">
					<template slot-scope="scope">
						{{scope.row.UserGender ? '男' : '女'}}
					</template>
				</el-table-column>
				<el-table-column prop="UserTel" align="center" label="联系电话"></el-table-column>
				<el-table-column prop="UserStatus" align="center" label="状态"></el-table-column>
				<el-table-column prop="UserType" align="center" label="用户类型"></el-table-column>
				<el-table-column prop="" align="center" label="负责经销商"></el-table-column>
				<el-table-column prop="RoleName" align="center" label="角色"></el-table-column>
				<el-table-column prop="UserName" align="center" label="角色设置">
					<template slot-scope="scope">
						<el-button type="text" @click="SetRoledialogVisible(scope)" size="small">设置</el-button>
					</template>
				</el-table-column>
				<el-table-column prop="UserName" align="center" label="操作">
					<template slot-scope="scope">
						<el-button type="text" @click="UpdataUser(scope)" size="small">编辑</el-button>
						<el-button type="text" @click="DisableUser(scope)" size="small">删除</el-button>
					</template>
				</el-table-column>
			</el-table>
		</div>
		<el-dialog title="设置角色" :visible.sync="dialogVisible" width="40%">
      		<el-table ref="multipleTable" highlight-current-row
    			@current-change="handleCurrentChange" :data="roles" border>
				<el-table-column type="index" align="center" width="55"></el-table-column>
				<el-table-column prop="RoleName" align="center" label="角色"></el-table-column>
				<el-table-column prop="RoleType" align="center" label="状态">
					<template slot-scope="scope">
						{{scope.row.RoleType ? '启用' : '禁用'}}
					</template>
				</el-table-column>
				<el-table-column prop="Remark" align="center" label="角色描述"></el-table-column>
			</el-table>
      		<span slot="footer" class="dialog-footer">
        		<el-button @click="dialogVisible = false">取 消</el-button>
        		<el-button type="primary" @click="SetRole">确 定</el-button>
      		</span>
    	</el-dialog>
	</div>
</template>

<script>
import {validateTwoPhone} from '../utils/rules'
export default {
	data(){
		var ruleconfirm = (rule, value, callback) => {
        	if (value === '') {
          		callback(new Error('请再次输入密码'));
        	} else if (value !== this.form.password) {
          		callback(new Error('两次输入密码不一致!'));
        	} else {
          		callback();
        	}
      		};
		return {
			form:{
				CID:'',
				userid:'',
				username:'',
				password:'',
				confirm:'',
				name:'',
				sex:true,
				tel:'',
				state:1,
				isAgcy:1,
				Agcyname:''
			},
			rules: {
        		username:[
          			{ required: true,  message: '请输入用户名', trigger: ['blur', 'change'] }
        		],
        		password:[
          			{ required: true,  message: '请输入密码', trigger: ['blur', 'change'] }
				],
				confirm:[
					{ required: true,  message: '请输入确认密码', trigger: ['blur', 'change'] },
					{ validator: ruleconfirm,trigger: "blur"}
				],
				
      		},
			options:[],
			tableData: [],
			dialogVisible: false,
			roles:[],
			userId:null,
			roleId:null,
			dialogtype:0
		};
	},
	mounted : function(){
		var user = JSON.parse(sessionStorage.getItem('user'));
		this.form.CID=user.QyNum;
		this.GetUsers();
		this.GetRole()
	},
	methods: {
		handleCurrentChange(row){
			if(row!=null){
				this.roleId = row.RoleId
			}
				
		},
		exitUpdata(){
			this.dialogtype=0
			this.restForm()
		},
		restForm(){
			this.$nextTick(()=>{
				this.$refs['form'].resetFields()
			})
		},
		AddUserInfo(form){
			this.$refs[form].validate((valid) => {
          		if (valid) {
					if(this.dialogtype==0){
						this.$axios({
							method: 'post',
							url:'/FW/SettingUser.ashx',
							params: {
								action:"AddUserInfo",
								form:this.form
							}
						}).then(res=>{
							if(res.Code==0){
								this.$message({
									showClose: true,
									message:res.Msg,
									type: 'success'
								});
								this.GetUsers()
							}else{
								this.$message({
									showClose: true,
									message:res.Msg,
									type: 'warning'
								});
							}       
						})
					}else if(this.dialogtype==1){
						this.$axios({
							method: 'post',
							url:'/FW/SettingUser.ashx',
							params: {
								action:"UpdateUserInfo",
								form:this.form
							}
						}).then(res=>{
							if(res.Code==0){
								this.$message({
									showClose: true,
									message:res.Msg,
									type: 'success'
								});
								this.GetUsers()
							}else{
								this.$message({
									showClose: true,
									message:res.Msg,
									type: 'warning'
								});
							}       
						})
					}
          		} else {
            		console.log('error submit!!');
            		return false;
          		}
        	});
		},
		GetUsers(){
			this.$axios({
        	method: 'post',
        	url:'/FW/SettingUser.ashx',
        	params: {
          		action:"GetUsers",
          		CID:this.form.CID
        	}
        	}).then(res=>{
          		if(res.Code==0){
            	this.tableData=res.Data;
          		}else{
					this.$message({
            			showClose: true,
            			message:res.Msg,
            			type: 'warning'
            		});
          		}       
      		})
		},
		GetRole(){
			//初始化获取角色
      		this.$axios({
        		method: 'post',
        		url:'/FW/RoleAssign.ashx',
        		params: {
					  action:"getRoles",
					  cid:this.form.CID
        		}
      		})
      		.then(res=>{
        		if(res.Code==0){
					this.roles=res.Data
        		}else{
          			this.$message({
            			showClose: true,
            			message:res.Msg,
            			type: 'warning'
            		});
        		}      
      		})
		},
		SetRoledialogVisible(scope){
			this.dialogVisible=true
			this.userId = scope.row.UserId
			this.$nextTick(()=>{
				this.$refs.multipleTable.setCurrentRow();
				this.roles.forEach(item =>{
				if(item.RoleId==scope.row.RoleId){
					this.$refs.multipleTable.setCurrentRow(item);
				}
				})
				
			})
		},
		SetRole(){
			this.$axios({
        		method: 'post',
        		url:'/FW/SettingUser.ashx',
        		params: {
					  action:"SetRole",
					  UserId:this.userId,
					  RoleId:this.roleId
        		}
      		})
      		.then(res=>{
        		if(res.Code==0){
          			this.$message({
            			showClose: true,
            			message:res.Msg,
            			type: 'success'
					});
					this.GetUsers()
        		}else{
          			this.$message({
            			showClose: true,
            			message:res.Msg,
            			type: 'warning'
            		});
        		}      
      		})
		},
		UpdataUser(scope){
			this.form.username=scope.row.UserName
			this.form.name=scope.row.DisplayName
			this.form.sex=scope.row.UserGender
			this.form.tel=scope.row.UserTel
			this.form.userid=scope.row.UserId
			this.form.isAgcy=scope.row.UserType
			this.form.state=scope.row.UserStatus
			this.form.password='111111'
			this.form.confirm='111111'
			this.dialogtype=1
		},
		DisableUser(scope){
			this.$axios({
				method: 'post',
				url:'/FW/SettingUser.ashx',
				params: {
					action:"DeleteUserInfo",
					UserId:scope.row.UserId
				}
			}).then(res=>{
				if(res.Code==0){
					this.$message({
						showClose: true,
						message:res.Msg,
						type: 'success'
					});
					this.GetUsers()
				}else{
					this.$message({
						showClose: true,
						message:res.Msg,
						type: 'warning'
					});
				}       
			})
		}
	}
}
</script>

<style scoped>
.title{
  text-align: left;
}
.btn{
	width: 500px;
	margin:0 150px;
}
.el-form-item {
	margin-bottom: 20px;
    width: 300px;
    display: inline-block;
}
</style>


// WEBPACK FOOTER //
// src/pages/settingUser.vue